<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="time"
        :label="label"
        prepend-icon="access_time"
        readonly
        v-on="on"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      v-model="time"
      full-width
      format="24hr"
      @click:minute="$refs.menu.save(time)"
      :disabled="disabled"
    ></v-time-picker>
  </v-menu>
</template>

<script>
  export default {
    name: 'TimePicker',
    props: {
      value: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: '',
      },
      rules: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      time: null,
      menu: false,
    }),
    created() {
      this.time = this.value;
    },
    watch: {
      time() {
        this.$emit('input', this.time);
      },
      value() {
        this.time = this.value;
      },
    },
  };
</script>

<style scoped>

</style>
